import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router'
import { Box, Grid, MenuItem, TextField, Typography } from '@material-ui/core'
import UploadProgramFileLogo from '../../elements/icons/uploadProgramFileLogo'
import { useFormik } from 'formik'
import * as yup from 'yup'
import { useStyles } from './style'
import { AppButton, Breadcrumb, DisplayMessage, Loader } from '../../Components'
import { Cards, OutlinedButton } from '../../elements'
import { programService } from '../../Services'
import { connect } from 'react-redux'
import _ from 'lodash'
import * as messageTypes from '../../utils/messageTypes'
import { MONTHLY_INSTALLMENT, programForm } from './formconstant'
import { applicationStatus, SITEALREADYEXISTSERROR, steps } from './constant'
import CustomStepper from '../../Components/CustomStepper'
import DownloadFile from '../../utils/downloadFile'
import { trimNameWithoutExtension } from '../../utils/fileUtils'
import download from '../../Assets/Images/download.svg'
import CustomDialog from '../../Components/CustomDialog'
import Icon from '../../utils/icons'
import Error404 from '../ErrorPages/Error404'
import errorIcon from '../../Assets/Images/errorIcon.svg'

const validationSchema = yup.object({
  isEdit: yup.boolean(),
  siteId: yup.string().when('isEdit', {
    is: false,
    then: yup.string().required('Site Id is required').min(2, 'Site Id must be min 2 characters').max(10, 'Site Id must be max 10 characters').test('maxval', 'Invalid Site ID', val => Number(val) < Math.pow(2, 31)),
  }),
  customerFirstName: yup.string().required('First name is required').min(2, 'First name must be min 2 characters').max(50, 'First name must be max 50 characters'),
  customerLastName: yup.string().required('Last name is required').min(2, 'Last name must be min 2 characters').max(50, 'Last name must be max 50 characters'),
  address1: yup.string().required('Address Line 1 is required').min(2, 'Address Line 1 must be min 2 characters').max(80, 'Address Line 1 must be max 80 characters'),
  address2: yup.string().min(2, 'Address Line 2 must be min 2 characters').max(80, 'Address Line 2 must be max 80 characters'),
  city: yup.string().required('City is required').min(2, 'City must be min 2 characters').max(30, 'City must be max 30 characters'),
  state: yup.string().required('State is required').min(2, 'State must be min 2 characters').max(30, 'State must be max 30 characters'),
  zip: yup.string().required('Zip is required').matches(/^[0-9]+$/, "Enter valid zip").min(5, 'Zip must be 5 characters').max(5, 'Zip must be 5 characters'),
  ean: yup.string().required('Electric account number is required').min(10, 'Electric account number must be min 10 characters').max(10, 'Electric account number must be max 10 characters'),
  paymentOptionType: yup.string().required('Please select program payment option type is required'),
  premiseId: yup.string().min(2, 'Optional Id must be min 2 characters').max(20, 'Optional Id must be max 20 characters').matches(/^([A-Za-z0-9]+)$/, 'Enter valid optional Id. Only alphanumeric values are allowed'),
  file: yup.string().when('isEdit', {
    is: false,
    then: yup.string().required('File is required and must be of max 10MB'),
  }),
})
const AddSystem = (props) => {
  const classes = useStyles()
  const [program, setProgram] = useState({})
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState()
  const [messageType, setMessageType] = useState()
  const [uploadTouched, setUploadTouched] = useState(false)
  const [loading, setLoading] = useState(false)
  const [submitModal, setSubmitModal] = useState(false)
  const [cancelModal, setCancelModal] = useState(false)
  const [errorModal, setErrorModal] = useState(false)
  const [errorMsg, setErrorMsg] = useState()
  const { programId } = useParams()
  const application = _.get(props, 'location.state.application', false)
  const { currentUser, history } = props

  const formik = useFormik({
    initialValues: {
      siteId: _.get(application, 'site_id', ''),
      customerFirstName: _.get(application, 'homeowner_info.first_name', ''),
      customerLastName: _.get(application, 'homeowner_info.last_name', ''),
      address1: _.get(application, 'homeowner_info.address1', ''),
      address2: _.get(application, 'homeowner_info.address2', ''),
      city: _.get(application, 'homeowner_info.city', ''),
      state: _.get(application, 'homeowner_info.state', ''),
      zip: _.get(application, 'homeowner_info.zip', ''),
      ean: _.get(application, 'homeowner_info.electric_account_number', ''),
      paymentOptionType: _.get(application, 'payment_method', MONTHLY_INSTALLMENT),
      file: '',
      isEdit: Boolean(application)
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      setSubmitModal(true)
    },
  })
  const addSystem = () => {
    setLoading(true)
    programService.addNewSystem(formik.values, currentUser, application ? 'put' : 'post', programId, application.application_id)
      .then(systemData => {
        setLoading(false)
        setOpen(true)
        setMessage('Application submitted successfully')
        setMessageType(messageTypes.SUCCESS)
        formik.resetForm()
        setSubmitModal(false)
        setTimeout(() => {
          history.push(`/programs/${programId}/systems-addition`)
        }, 2000)
      })
      .catch(error => {
        setLoading(false)
        setSubmitModal(false)
        if (_.get(error, 'data.error.displayMessage') === SITEALREADYEXISTSERROR) {
          setErrorMsg(_.get(error, 'data.error.displayMessage', ''))
          setErrorModal(true)
        } else {
          setOpen(true)
          setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
          setMessageType(messageTypes.ERROR)
        }
      })
  }

  const getProgram = () => {
    programService.getProgramsById(currentUser.account_id, programId)
      .then(programData => {
        setProgram(programData)
      })
      .catch(error => {
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const goBack = (formik) => {
    if (formik.dirty) {
      setCancelModal(true)
    } else {
      history.push(`/programs/${programId}/systems-addition`)
    }
  }

  const getCancelModalContent = () => (
    <Box>
      <Typography className={classes.modalText}>The Application is not submitted yet. Are you sure you want to leave this page?</Typography>
      <Box display="flex">
        <AppButton className={classes.modalButton} text="Yes" fill={false} onClick={() => history.push(`/programs/${programId}/systems-addition`)} />
        <AppButton className={classes.modalButton} text="No" onClick={() => setCancelModal(false)} />
      </Box>
    </Box>
  )

  const getSubmitModalContent = () => (
    <Box>
      <Typography className={classes.modalText}>Are you sure you want to submit the application?</Typography>
      <Box display="flex">
        <AppButton className={classes.modalButton} text="Yes" onClick={() => addSystem()} />
        <AppButton className={classes.modalButton} text="No" fill={false} onClick={() => setSubmitModal(false)} />
      </Box>
    </Box>
  )

  const getErrorModalContent = () => (
    <Box>
      <Box display="flex" justifyContent="center" mb={2}>
        <img src={errorIcon} alt="" />
      </Box>
      <Typography className={classes.modalErrorText}>{errorMsg}</Typography>
    </Box>
  )

  const renderIcon = (touched, errors) => {
    return touched ? _.isUndefined(errors) ? <Icon src="circleTick" /> : <Icon src="circleCross" /> : <></>
  }

  useEffect(() => {
    getProgram()
  }, [])
  const renderAddSystem = () => (
    <>
      <Box className={classes.formCardContent}>
        <form onSubmit={formik.handleSubmit}>
          <>
            <Grid container spacing={4}>
              <Grid item xs={12} md={6}>
                <Box className={classes.formCardHeading} p={1}>Enter the following details</Box>
                {programForm.map(formData => {
                  if (formData.type === 'textField') {
                    return (
                      <Box m={1}>
                        <TextField
                          id={formData.id}
                          label={formData.label}
                          name={formData.name}
                          fullWidth
                          InputProps={{
                            endAdornment: renderIcon(formik.touched[formData.name], formik.errors[formData.name]),
                          }}
                          style={{ maxWidth: 500 }}
                          value={formik.values[formData.name]}
                          onChange={formik.handleChange}
                          onBlur={(e) => formik.setFieldValue(formData.name, e.target.value.trim())}
                          error={formik.touched[formData.name] && Boolean(formik.errors[formData.name])}
                          helperText={formik.touched[formData.name] && formik.errors[formData.name]}
                        />
                      </Box>
                    )
                  } else if (formData.type === 'numeric') {
                    return (
                      application && formData.name === 'siteId' ? '' :
                        <Box m={1}>
                          <TextField
                            id={formData.id}
                            label={formData.label}
                            name={formData.name}
                            fullWidth
                            InputProps={{
                              endAdornment: renderIcon(formik.touched[formData.name], formik.errors[formData.name]),
                            }}
                            disabled={application && formData.name === 'siteId'}
                            style={{ maxWidth: 500 }}
                            value={formik.values[formData.name]}
                            onChange={formik.handleChange}
                            onInput={(e) => {
                              e.target.value = e.target.value.replace(/[^0-9]*/g, '')
                            }}
                            error={formik.touched[formData.name] && Boolean(formik.errors[formData.name])}
                            helperText={formik.touched[formData.name] && formik.errors[formData.name]}
                          />
                        </Box>
                    )
                  } else if (formData.type === 'select') {
                    return (
                      <Box m={1}>
                        <TextField
                          id={formData.id}
                          select
                          label={formData.label}
                          name={formData.name}
                          fullWidth
                          style={{ maxWidth: 500 }}
                          value={formik.values[formData.name]}
                          onChange={formik.handleChange}
                          InputProps={{
                            classes: { root: classes.input }
                          }}
                          SelectProps={{
                            MenuProps: {
                              classes: { paper: classes.paper },
                              anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "left"
                              },
                              getContentAnchorEl: null
                            }
                          }}
                          error={formik.touched[formData.name] && Boolean(formik.errors[formData.name])}
                          helperText={formik.touched[formData.name] && formik.errors[formData.name]}
                        >
                          {formData.dropdownOptions.map(option => (
                            <MenuItem value={option.value}>{option.label}</MenuItem>
                          ))}
                        </TextField>
                      </Box>
                    )
                  }
                })}
              </Grid>
              <Grid item xs={12} md={6}>
                <Box className={classes.formCardHeading} p={1}>File to be uploaded</Box>
                <Box className={classes.fileUploadSpace} m={1} px={2}>
                  {(
                    <>
                      <UploadProgramFileLogo />
                      <Typography className={classes.uploadText}>
                        Application Form
                      </Typography>
                      <input
                        accept=".pdf"
                        className={classes.uploadInput}
                        id="file"
                        name="file"
                        type="file"
                        onClick={(e) => e.target.value = ''}
                        onChange={(e) => {
                          let file
                          if (e.target.files && e.target.files[0] && e.target.files[0].type !== 'application/pdf') {
                            setOpen(true)
                            setMessage('Only PDF files are allowed')
                            setMessageType(messageTypes.ERROR)
                          } else {
                            file = e.target.files && e.target.files[0]
                            setUploadTouched(true)
                          }
                          if (file) {
                            if (file.size <= 10485760) {
                              formik.setFieldValue('file', file)
                            } else {
                              formik.setFieldError('file', 'File is required and must be of max 10MB')
                            }
                          }
                        }}
                      />
                      <label htmlFor="file" style={{ width: "100%" }}>
                        <AppButton className={classes.uploadButton} fullWidth text={`${formik.values.file ? "Re-Upload" : "Upload"}`} fill={false} component="span" />
                      </label>
                      {formik.values.file && <div className={classes.fileName}>{formik.values.file.name}</div>}
                      {formik.touched.file && formik.errors.file && <div className={`${classes.error} ${classes.center}`}>{formik.errors.file}</div>}
                      {!formik.values.file && application && application.signed_application_form_downloadable_url &&
                        <Box className={`${classes.fileName} ${classes.fileEdit}`} component="span" onClick={() => { application && application.signed_application_form_downloadable_url && DownloadFile(application.signed_application_form_downloadable_url) }}>
                          <Box><img src={download} className={classes.downloadIcon} alt="" />
                            {trimNameWithoutExtension(application.signed_application_form_url.split('/')[application.signed_application_form_url.split('/').length - 1])}</Box>
                        </Box>
                      }
                      <Box className={classes.uploadHelperTextWrapper}>
                        <Box className={classes.uploadHelperText}>
                          File number limit : 1
                        </Box>
                        <Box className={classes.uploadHelperText}>
                          Size limit : 10MB
                        </Box>
                        <Box className={classes.uploadHelperText}>
                          Allowed file types : PDF
                        </Box>
                      </Box>
                    </>
                  )}
                </Box>
              </Grid>
            </Grid>
          </>
          <Typography style={{ margin: '50px 0 50px 7px', color: '#0000008A' }}>
            I have consent to provide this personal information. Review Enphase's&nbsp;
            <a href="https://enphase.com/privacy" target="_blank" className={classes.privacyPolicy}>Privacy Policy</a>&nbsp;here.
          </Typography>
          <Box display="flex" justifyContent="flex-end" width="100%">
            <Box display="flex" flexWrap="wrap" width="100%" maxWidth="500px">
              <AppButton className={classes.mr2} type="submit" fullWidth text="Submit" />
              <AppButton fill={false} fullWidth text="Back" onClick={() => goBack(formik)} />
            </Box>
          </Box>
        </form>
      </Box>
    </>
  )

  const getBreadcrumbs = () => {
    let value = [{ 'Home': '/' }, { 'Programs': '/programs' }]
    if (program) {
      value.push({ [program?.program_name_admin_ui]: `/programs/${program.id}` })
      value.push({ 'Systems Addition': `/programs/${program.id}/systems-addition` })
      value.push({ [application ? 'Edit Application' : 'Add a New System']: '' })
    } else {
      value.push({ [application ? 'Edit Application' : 'Add a New System']: '' })
    }
    return value
  }

  if (program && program.feature_flags && program.feature_flags.system_enrollment_option !== 'SYSTEM_ADDITION') {
    return (<Error404 />)
  }

  return (
    <Box>
      <Breadcrumb value={getBreadcrumbs()} />
      <DisplayMessage open={open} message={message} messageType={messageType} handleClose={() => setOpen(false)} />
      <Loader loading={loading} />
      <CustomDialog open={cancelModal} fullWidth maxWidth="xs" title="" content={getCancelModalContent()} handleClose={() => setCancelModal(false)} />
      <CustomDialog open={submitModal} fullWidth maxWidth="xs" title="" content={getSubmitModalContent()} handleClose={() => setSubmitModal(false)} />
      <CustomDialog open={errorModal} fullWidth maxWidth="xs" title="" content={getErrorModalContent()} handleClose={() => setErrorModal(false)} />
      <Box className={classes.headerWrapper}>
        <Typography className={classes.subPageTitle}>{application ? `Edit Application for Site ID : ${application.site_id}` : 'Add a New System'}</Typography>
      </Box>
      <Box className={classes.stepperContainer}>
        <CustomStepper steps={steps} currentStep={application ? applicationStatus[application.application_status][2] : 0} status={application && application.application_status} />
      </Box>
      <Cards className={classes.cardWrapper} children={renderAddSystem()} />
    </Box>
  )
}

const mapStateToProps = ({ auth }) => {
  const { authUser, currentUser, isSuperAdmin, isAdmin } = auth
  return { authUser, currentUser, isSuperAdmin, isAdmin }
}

export default connect(mapStateToProps, {})(AddSystem)